import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdesaoService } from 'src/app/services/adesao.service';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { RecebimentosService } from 'src/app/services/recebimentos.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { UtilService } from 'src/app/services/util.service';
declare var $: any;

@Component({
    selector: 'app-recebimentos',
    templateUrl: './recebimentos.component.html',
    styleUrls: ['./recebimentos.component.css'],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, NgxPaginationModule]
})
export class RecebimentosComponent implements OnInit {

  loading = false;
  loadingGerarBoleto = false;

  listPrimeiroAnoMes: any[] = [];
  listUltimoAnoMes: any[] = [];
  listStatusCob: any[] = [];

  formFiltro: FormGroup;

  paginaAtual = 1;
  qntPorPage = 10;

  movimentacoes: any[] = [];

  itemSelecionado: any = null;
  dadosBoleto: any = null;

  constructor(
    private utilService: UtilService,
    private router: Router,
    private adesao: AdesaoService,
    private autenticacao: AutenticacaoService,
    private recebimentos: RecebimentosService,
    private toastr: ToastrService
  ) {
    this.formFiltro = new FormGroup({
      codStatus: new FormControl(''),
      anomesInicio: new FormControl(0),
      anomesFim: new FormControl(0),
      tipoOrdem: new FormControl(0),
    });
  }

  copyToClipboardAndToast(valueToCopy: string, msg: string) {
    navigator.clipboard.writeText(valueToCopy);
    this.toastr.success(msg);
  }


  ngOnInit() {
    this.listar();
    this.listarFiltros();
  }

  listar() {
    this.loading = true;

    this.recebimentos
      .listar(this.formFiltro.getRawValue())
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        (res: any) => {
          this.movimentacoes = res.dados || [];
          this.movimentacoes.forEach(x => x.loadingBoleto = false);
          this.setaStatus();
        },
        () => {
          this.toastr.error('Erro ao carregar movimentações.');
        }
      );
  }

  listarFiltros() {
    this.recebimentos
      .listarFiltros()
      .subscribe(
        (res: any) => {
          this.listPrimeiroAnoMes = res.anoMes || [];
          this.listUltimoAnoMes = res.anoMes || [];
          this.listStatusCob = res.statusCob || [];
        },
        () => {
          this.toastr.error('Erro ao carregar filtros.');
        }
      );
  }

  setaStatus() {
    const dataAtual = new Date();

    this.movimentacoes.forEach(item => {
      const datavenc = new Date(item.DTA_VENC.replace(/-/g, '\/'));

      if (new Date(datavenc) < dataAtual && !item.DTA_PGTO) {
        item.STATUS = 'Pendente';
        item.CLASSE = 'status red';
      } else if (item.DTA_PGTO) {
        item.STATUS = 'Pago';
        item.CLASSE = 'status gray';
      } else {
        item.STATUS = 'A vencer';
        item.CLASSE = 'status blue';
      }
    });
  }

  buscarDadosBoleto(item: any) {
    item.loadingBoleto = true;

    this.recebimentos
      .dadosBoleto(item.COD_COBRANCA)
      .pipe(finalize(() => item.loadingBoleto = false))
      .subscribe(
        (res: any) => {
          this.dadosBoleto = res;
          $('#modalBoleto').modal('show');
          this.listar();
        },
        (error: HttpErrorResponse) => {
          this.toastr.error((error.error && error.error.ex) ? error.error.ex : 'Erro ao buscar dados do boleto');
        }
      );
  }

  async gerarPDFBoleto() {
    this.loadingGerarBoleto = true;

    this.recebimentos
      .gerarBoleto(this.dadosBoleto && this.dadosBoleto.COD_COBRANCA)
      .pipe(finalize(() => this.loadingGerarBoleto = false))
      .subscribe(
        (res: Blob) => {
          const contentType = res.type;

          if (contentType === 'application/pdf') {
            this.utilService.salvarArquivo(res, 'boleto_vmp.pdf');
          } else {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result as string);
                this.toastr.error(json.mensagem || 'Erro ao gerar boleto');
              } catch {
                this.toastr.error('Erro desconhecido ao processar resposta do servidor');
              }
            };
            reader.readAsText(res);
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse && error.error instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result as string);
                this.toastr.error(json.mensagem || 'Erro ao gerar boleto');
              } catch {
                this.toastr.error('Erro desconhecido ao processar resposta do servidor');
              }
            };
            reader.readAsText(error.error);
          } else {
            this.toastr.error('Erro inesperado ao gerar boleto');
          }
        }
      );
  }

  print() {
    window.print();
  }
}
